export function authHeader() {
    // return authorization header with jwt token
    let user = null
    try {
        user = JSON.parse(localStorage.getItem('user'));
    } catch (error) {
        localStorage.removeItem('user');
        localStorage.removeItem('token');
    }
    let token = localStorage.getItem('token')
    if (user && token) {
        return { 'Authorization': 'Bearer ' + token };
    } else {
        return {};
    }
}
